import { defaultMemberFormData } from '../../../../subcomponents/member-form/types/data';
export const defaultUpdateMemberDetailsFormData = defaultMemberFormData;
//# sourceMappingURL=data.js.map